/**
 * Slow editorial marquee. CSS-only, respects prefers-reduced-motion.
 * Content is duplicated so the loop reads seamlessly.
 */
export const Marquee = ({ items = [], speed = 55, className = "", testid }) => {
  const track = [...items, ...items];
  return (
    <div
      className={`relative w-full overflow-hidden select-none ${className}`}
      data-testid={testid}
      aria-hidden="true"
    >
      <div
        className="flex whitespace-nowrap will-change-transform marquee-track"
        style={{ animationDuration: `${speed}s` }}
      >
        {track.map((t, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="px-8 md:px-12">{t}</span>
            <span className="inline-block h-2 w-2 rotate-45 bg-terracotta" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
